import { animate, inView, scroll, spring, stagger, ScrollOffset } from "motion";

for (const item of document.getElementsByClassName("fade-in")) {
	inView(
		item,
		(entry) =>
			animate(
				entry.target,
				{
					opacity: [0, 1],
				},
				{
					easing: "ease-in",
					delay: stagger(0.3, {
						start: 0.3,
					}),
				},
			).stop,
	);
}

for (const item of document.getElementsByClassName("from-above")) {
	inView(
		item,
		(entry) =>
			animate(
				entry.target,
				{
					y: [-100, 0],
				},
				{
					easing: spring(),
					delay: stagger(0.3, {
						start: 0.3,
					}),
				},
			).stop,
	);
}

for (const item of document.getElementsByClassName("from-left")) {
	inView(
		item,
		(entry) =>
			animate(
				entry.target,
				{
					x: [-100, 0],
				},
				{
					easing: spring(),
					delay: stagger(0.3, {
						start: 0.3,
					}),
				},
			).stop,
	);
}

for (const item of document.getElementsByClassName("from-below")) {
	inView(
		item,
		(entry) =>
			animate(
				entry.target,
				{
					y: [100, 0],
				},
				{
					easing: spring(),
					delay: stagger(0.3, {
						start: 0.3,
					}),
				},
			).stop,
	);
}

for (const item of document.getElementsByClassName("from-right")) {
	inView(
		item,
		(entry) =>
			animate(
				entry.target,
				{
					x: [100, 0],
				},
				{
					easing: spring(),
					delay: stagger(0.3, {
						start: 0.3,
					}),
				},
			).stop,
	);
}

for (const item of document.getElementsByClassName("parallax-y")) {
	scroll(
		animate(item, {
			transform: ["translateY(0)", "translateY(50%)"],
		}),
		{
			target: item,
			offset: ScrollOffset.Exit,
		},
	);
}

for (const item of document.getElementsByClassName("zoom-in")) {
	inView(
		item,
		(entry) =>
			animate(
				entry.target,
				{
					scale: [0.9, 1],
				},
				{
					easing: spring(),
					delay: stagger(0.3, {
						start: 0.3,
					}),
				},
			).stop,
	);
}
